import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { LoadingBackDrop } from "../../../components/loader";
import { theme } from "../../../helpers/theme";
import { getAllOperatorClients } from "../../../services/clients";
import { GetAllOperatorClients } from "../../../services/clients/types";

interface ClientPickProps {
  setClientId: (clientId: string | null) => void;
  clientId: string | null;
  // setFormValid: (formValid: boolean) => void;
  setClientAddDisabled: (clientAddActive: boolean) => void;
  setClientDataValid: (clientDataValid: boolean) => void;
}

const ClientPick = ({setClientId, clientId, setClientAddDisabled, setClientDataValid}:ClientPickProps) => {

  const [clients, setClients] = useState<GetAllOperatorClients[]>([]);


const body = {
  paginacja: null,
  filtr: null,
};

const GetAllClients = useQuery(
  ["AllOperatorClients"],
  () => getAllOperatorClients(body),
  {
    refetchOnMount: true,
    refetchOnWindowFocus: false,

    onSuccess(data) {
      setClients(data.data.payload.klienci);
    },
  }
);

const formik = useFormik({
  initialValues: {
    klient_id: clientId === null ? "0" : clientId,
  },
  onSubmit: (values) => {
  },
});

useEffect(() => {
  // console.log("formik.values.klient_id", formik.values.klient_id);
  if (formik.values.klient_id) {
    if (formik.values.klient_id === "0") {
      setClientAddDisabled(false);
      setClientId(null);
      // console.log("Klient o id 0, zmiana na false")
      setClientDataValid(false);
    } else {
      setClientId(formik.values.klient_id);
      setClientAddDisabled(true);
      // console.log("Klient o id innym niż 0 wybrany z listy, zmiana na true")
      setClientDataValid(true);
    }
  }
}, [formik.values.klient_id]);

if (GetAllClients.isLoading || GetAllClients.isRefetching) {
  return <LoadingBackDrop loading={true} />;
}
  return ( 
    <ClientPickerWrapper>
      <FormControl fullWidth>
        <InputLabel id="klienciLabel">Wybierz klienta</InputLabel>
        <Select
          placeholder="Klienci"
          labelId="klienciLabel"
          id="klienci"
          name="klient_id"
          value={formik.values.klient_id}
          label="Wybierz klienta"
          onChange={formik.handleChange}
          // disabled={!isEditable}
          style={{ backgroundColor: "white" }}
        >
          <MenuItem key={0} value={"0"}> Dodaj nowego klienta </MenuItem>
          {clients
            .filter((item) => item.uzytkownik === null)
            .map((item) => (
              <MenuItem key={item.id_klient} value={item.id_klient}>
                {item.nazwa}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      {/* <TextContainer>
        Lub dodaj nowego klienta
      </TextContainer> */}
      {/* Lub
      <StyledButton
        onClick={() => {
          return navigate(`/operator/clients/add`);
        }}
      >
        Dodaj nowego klienta
      </StyledButton> */}
    </ClientPickerWrapper>
  );
}

export default ClientPick;

const ClientPickerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // width: 45%;
  `

const TextContainer = styled.div`
  margin-top: 25px;
  // margin-bottom: 20px;
  font-size: 20px;
  font-weight: 500;
  font-family: ${theme.fonts.interMedium};
`